window.TickTastic = class TickTastic {
  countdowns = [
    "22:00",
    "22:00",
    "22:00",
    "22:00",
    "22:00",
    "17:00",
    "22:00",
  ];
  inbetween_countdowns = [
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
    "00:00",
  ];
  before_texts = [
    "Bestill før: %countdown% (%deadline%) så sender vi i dag",
    "Bestill før: %countdown% (%deadline%) så sender vi i dag",
    "Bestill før: %countdown% (%deadline%) så sender vi i dag",
    "Bestill før: %countdown% (%deadline%) så sender vi i dag",
    "Bestill før: %countdown% (%deadline%) så sender vi i dag",
    "Bestill før: %countdown% (%deadline%) så sender vi i dag",
    "Bestill før: %countdown% (%deadline%) så sender vi i dag",
  ];
  inbetween_texts = [
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
  ];
  after_texts = [
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
    "Bestill i kveld, så sender vi i morgen",
  ];
  dayOfTheWeek = new Date().getDay();
  target = null;
  target_before = null;
  target_inbetween = null;
  target_after = null;
  format = "short";
  identifier = null;
  seperate_countdown = false;
  constructor(identifier, format, seperate_countdown) {
    if (identifier === undefined || identifier === null) {
      return;
    }
    this.identifier = identifier;
    this.format = format || "short";
    this.seperate_countdown = seperate_countdown || false;
    this.render();
  }
  render() {
    let target = document.querySelector(this.identifier);
    if (!target) {
      return;
    }
    this.target = target;
    this.target_before = target.querySelector(".before");
    this.target_inbetween = target.querySelector(".inbetween");
    this.target_after = target.querySelector(".after");
    this.target_countdown = target.querySelector(".countdown");

    let time = this.countdowns[this.dayOfTheWeek];
    let inbetween = this.inbetween_countdowns[this.dayOfTheWeek];

    if (this.target_before) {
      target.querySelector(".before").innerHTML = this.replaceVariables(
        this.before_texts[this.dayOfTheWeek]
      );
    }
    if (this.target_inbetween) {
      target.querySelector(".inbetween").innerHTML = this.replaceVariables(
        this.inbetween_texts[this.dayOfTheWeek]
      );
    }
    if (this.target_after) {
      target.querySelector(".after").innerHTML = this.replaceVariables(
        this.after_texts[this.dayOfTheWeek]
      );
    }
    if (this.target_countdown && this.seperate_countdown) {
      this.target_countdown.innerHTML = `<span class="timer" data-time="${time}" data-inbetween="${inbetween}" data-weekday="${this.dayOfTheWeek}"></span>`;
    }

    this.startTimer();
  }

  replaceVariables(text) {
    const lang = document.querySelector("html").lang;
    let today = new Date().toLocaleString(
      lang,
      { weekday: "long" }
    );
    let tomorrow = new Date();

    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow = tomorrow.toLocaleString(
      lang,
      { weekday: "long" }
    );

    let dayAfterTomorrow = new Date();

    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
    dayAfterTomorrow = dayAfterTomorrow.toLocaleString(
      lang,
      { weekday: "long" }
    );

    text = text.replaceAll("%today%", `<span class="today">${today}</span>`);
    text = text.replaceAll(
      "%tomorrow%",
      `<span class="tomorrow">${tomorrow}</span>`
    );
    text = text.replaceAll(
      "%day_after_tomorrow%",
      `<span class="day_after_tomorrow">${dayAfterTomorrow}</span>`
    );
    text = text.replaceAll(
      "%deadline%",
      this.seperate_countdown
        ? ""
        : `<span class="deadline">${this.countdowns[this.dayOfTheWeek]}</span>`
    );
    text = text.replaceAll(
      "%deadline_inbetween%",
      `<span class="deadline">${
        this.seperate_countdown
          ? ""
          : this.inbetween_countdowns[this.dayOfTheWeek]
      }</span>`
    );
    if (this.seperate_countdown) {
      text = text.replaceAll("(", "").replaceAll(")", "");
    }
    text = text.replaceAll(
      "%countdown%",
      this.seperate_countdown
        ? ""
        : `<span class="timer" data-time="${
            this.countdowns[this.dayOfTheWeek]
          }" data-inbetween="${
            this.inbetween_countdowns[this.dayOfTheWeek]
          }" data-weekday="${this.dayOfTheWeek}"></span>`
    );
    return text;
  }

  startTimer() {
    this.timerInterval();
    this.countdown_interval = setInterval(() => {
      this.timerInterval();
    }, 1000);
  }

  timerInterval() {
    let time = this.countdowns[this.dayOfTheWeek];
    let deadline = new Date();
    let hours = time.split(":")[0];
    let minutes = time.split(":")[1];

    deadline.setHours(hours);
    deadline.setMinutes(minutes);
    deadline.setSeconds(0);

    let timer_inbetween = this.inbetween_countdowns[this.dayOfTheWeek];
    let hours_inbetween = timer_inbetween.split(":")[0];
    let minutes_inbetween = timer_inbetween.split(":")[1];

    let deadline_inbetween = new Date();
    deadline_inbetween.setHours(hours_inbetween);
    deadline_inbetween.setMinutes(minutes_inbetween);
    deadline_inbetween.setSeconds(0);

    
    let is_inbetween =
      Date.now() < deadline_inbetween.getTime() &&
      Date.now() > deadline.getTime() &&
      this.target.querySelector(".inbetween");

    let countdown_till_tomorrow = false;
    if (is_inbetween) {
      time = Math.round((Date.now() - deadline_inbetween.getTime()) / 1000);
    } else {
      time = Math.round((deadline.getTime() - Date.now()) / 1000);
      if (time < 0) {
        countdown_till_tomorrow = true;
        deadline.setDate(deadline.getDate() + 1);
        time = Math.round((deadline.getTime() - Date.now()) / 1000);
      }
    }
    time = Math.abs(time);

    let timer = null;

    if (time > 0 && !countdown_till_tomorrow) {
      if (is_inbetween) {
        timer = this.target.querySelector(".inbetween .timer");
        this.togglevisibility(this.target, "inbetween");
      } else {
        timer = this.target.querySelector(".before .timer");
        this.togglevisibility(this.target, "before");
      }

      if (this.seperate_countdown) {
        timer = this.target_countdown.querySelector(".timer");
        timer.dataset.visible = "true";
      }
    }

    if (time <= 0 || countdown_till_tomorrow) {
      timer = this.target.querySelector(".after .timer");

      if (this.seperate_countdown) {
        timer = this.target_countdown.querySelector(".timer");
        timer.dataset.visible = "true";
      }
      if (!countdown_till_tomorrow) {
        clearInterval(this.countdown_interval);
        if (timer && this.seperate_countdown) {
          timer.dataset.visible = "false";
        }
      }
      this.togglevisibility(this.target, "after");
    }

    this.renderTime(timer, time);
  }

  togglevisibility(target, is_counting) {
    let before = target.querySelector(".before");
    let inbetween = target.querySelector(".inbetween");
    let after = target.querySelector(".after");

    if (after) after.dataset.visible = "false";
    if (before) before.dataset.visible = "false";
    if (inbetween) inbetween.dataset.visible = "false";
    switch (is_counting) {
      case "after":
        if (after) after.dataset.visible = "true";
        break;
      case "inbetween":
        if (inbetween) inbetween.dataset.visible = "true";
        break;
      case "before":
        if (before) before.dataset.visible = "true";
        break;
    }
  }

  renderTime(target, time) {
    if (!target) {
      return;
    }
    let hours = Math.floor(time / 3600);
    let minutes = Math.floor((time - hours * 3600) / 60);
    let seconds = time - hours * 3600 - minutes * 60;
    
    if (this.format === "long") {
      let string_hours = String(hours).padStart(2, "");
      let string_minutes = String(minutes).padStart(2, "0");
      let string_seconds = String(seconds).padStart(2, "0");

      let rtf1 = new Intl.RelativeTimeFormat(
        document.querySelector("html").lang,
        { numeric: "auto" }
      );
      let partsHours = rtf1.formatToParts(
        hours === 0 ? "59" : string_hours,
        "hour"
      );
      let partsMinutes = rtf1.formatToParts(
        minutes === 0 ? "59" : string_minutes,
        "minute"
      );
      let partsSeconds = rtf1.formatToParts(
        seconds === 0 ? "59" : string_seconds,
        "second"
      );
      
      let hour_text = partsHours[2].value;
      let minute_text = partsMinutes[2].value;
      let second_text = partsSeconds[2].value;
      
      // HH:MM:SS
      if (hours > 0 && minutes > 0) {
        target.innerHTML = `${
          String(string_hours).substring(0, 2) + hour_text} ${
          String(string_minutes).substring(0, 2) + minute_text} ${
          String(string_seconds).substring(0, 2) + second_text}
        `;
        
      // HH:SS
      } else if (hours > 0 && minutes === 0) {
        target.innerHTML = `${
          String(string_hours).substring(0, 2) + hour_text} ${
          String(string_seconds).substring(0, 2) + second_text}
        `;
        
      // SS
      } else if (hours === 0 && minutes === 0) {
        target.innerHTML = `${
          String(string_seconds).substring(0, 2) + second_text}
        `;
        
      // MM:SS
      } else {
        target.innerHTML = `${
          String(string_minutes).substring(0, 2) + minute_text} ${
          String(string_seconds).substring(0, 2) + second_text}
        `;
      }

    } else {
      hours = String(hours).padStart(2, "0");
      minutes = String(minutes).padStart(2, "0");
      seconds = String(seconds).padStart(2, "0");

      target.innerHTML = `${String(hours).substring(0, 2)}:${String(
        minutes
      ).substring(0, 2)}:${String(seconds).substring(0, 2)}`;
    }
  }
}
document.dispatchEvent(new CustomEvent("ticktastic.ready"));